export function formatDate(date) {
    const localDate = new Date(date);

    return localDate.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',  // "May"
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true    // Use 24-hour time
    });
}